import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { DropdownSearchStyled } from "./styled";
import Select from "react-select";
import theme from "styles/theme.json";

const DropdownSearch = ({
  theme_standard,
  label,
  options,
  value,
  onChange,
  onChaneCustom,
  placeholder,
  errors,
  disabled,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      boxSizing: "border-box",
      background: disabled ? theme.COLORS.GRAY_4 : theme.COLORS.WHITE_1,
      border: `0.0625rem solid ${theme.COLORS.GRAY_1}`,
      borderRadius: "1rem",
      minHeight: "2.75rem",
      boxShadow: "none",
      padding: "0 0.75rem",
      "&:hover": {
        border: `0.0625rem solid ${theme.COLORS.GRAY_1}`,
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: theme.COLORS.BLUE_2,
      fontSize: theme.FONT.SIZE.S13,
      fontFamily: theme.FONT.STYLE.KANIT_REGULAR,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme.COLORS.BLUE_2,
      fontSize: theme.FONT.SIZE.S14,
      fontFamily: theme.FONT.STYLE.KANIT_REGULAR,
    }),
    input: (provided) => ({
      ...provided,
      color: theme.COLORS.BLUE_2,
      fontSize: theme.FONT.SIZE.S14,
      fontFamily: theme.FONT.STYLE.KANIT_REGULAR,
    }),
    menu: (provided) => ({
      ...provided,
      color: theme.COLORS.BLUE_2,
      fontSize: theme.FONT.SIZE.S13,
      fontFamily: theme.FONT.STYLE.KANIT_REGULAR,
      backgroundColor: theme.COLORS.WHITE_1,
      borderRadius: "5px",
      zIndex: 99,
    }),
  };

  const selectedOption =
    (options || []).find((e) => e.value === value) || null;

  return (
    <DropdownSearchStyled disabled={disabled}>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <Select
          isDisabled={disabled}
          isSearchable
          isClearable
          styles={customStyles}
          placeholder={placeholder || "Select..."}
          value={selectedOption}
          onChange={(e) => {
            const val = e ? e.value : "";
            onChange(val);
            onChaneCustom && onChaneCustom(val);
          }}
          options={options || []}
        />
        {errors && <div className="errors">{errors}</div>}
      </div>
    </DropdownSearchStyled>
  );
};

DropdownSearch.propTypes = {};

export default DropdownSearch;
